// extracted by mini-css-extract-plugin
export default {"container":"About_container__LWwrg","link":"About_link__eGtpX","mediumBody":"About_mediumBody__0+1Qv","details":"About_details__LDeyK","licence":"About_licence__CYqnc"};